// Components==============
import { motion } from 'framer-motion';
import React, { useContext } from 'react';
import { MenuContext } from '../../Menu';
import './Pointer.module.scss';
// =========================

export default function Pointer() {
    const { selected, menuY } = useContext(MenuContext);

    return (
        <motion.div
            styleName="wrapper"
            animate={{
                x: selected === 'initial' ? 0 : -10,
                y: menuY,
            }}
            initial={{
                x: selected === 'initial' ? 0 : -10,
                y: menuY,
            }}
            transition={{
                y: {
                    type: 'spring',
                    duration: 0.8,
                    bounce:
                        selected === 'city' || selected === 'cog' ? 0.2 : 0.35,
                },
            }}
        >
            <svg width="11.2" height="45.465" viewBox="0 0 11.2 45.465">
                <defs>
                    <clipPath id="clip-path">
                        <rect
                            id="Rectangle_183"
                            data-name="Rectangle 183"
                            width="11.2"
                            height="45.465"
                            transform="translate(0 0)"
                            fill="none"
                        />
                    </clipPath>
                </defs>
                <g
                    id="Group_190"
                    data-name="Group 190"
                    transform="translate(0 0)"
                >
                    <g
                        id="Group_190-2"
                        data-name="Group 190"
                        clipPath="url(#clip-path)"
                    >
                        <path
                            id="Path_652"
                            data-name="Path 652"
                            d="M11.2,0A16.893,16.893,0,0,1,4.586,13.694a11.2,11.2,0,0,0,0,18.077A16.893,16.893,0,0,1,11.2,45.465Z"
                            fill="#181818"
                        />
                    </g>
                </g>
            </svg>
        </motion.div>
    );
}
